import React, { FC, useEffect, useState } from 'react';
import {
  EBundlesInternalViewModel,
  EGradientDirection,
  EProductPriority,
} from 'utils/enums';
import { BundleProps } from 'utils/types';
import { StyledPlaydogBundle } from './styles';

import { MainProduct, SubProduct } from './elements';
import { BundlePrice } from 'components/BundlePrice';

export const PlaydogBundle: FC<BundleProps> = ({
  prices,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#406cf9',
    colorTwo: '#6449ff',
    gradientDirection: EGradientDirection.TopToBottom,
  },
  bundleButtonColor,
  bundleButtonTextColor,
  salePercentage = 0,
  fontFamily,
  inMobileMock,
}) => {
  const [mainProduct, setMainProduct] = useState<any>(null);
  const [subProducts, setSubProducts] = useState<any>([]);

  useEffect(() => {
    let main = productList.find(
      (product) => product.priority === EProductPriority.MAIN,
    );
    const sub = productList.filter(
      (product) => product.priority === EProductPriority.SUB,
    );

    setMainProduct(main);
    setSubProducts(sub);
  }, [productList]);

  return (
    <StyledPlaydogBundle
      productColor={
        productList.length > 0 ? productList[0].textFontColorHex : ''
      }
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      fontFamily={fontFamily}
      className="playdog-bundle"
      priceDisplay={prices?.priceDisplay || ''}
      isMainProduct={!!mainProduct}
    >
      <div className="playdog-bundle-products">
        {mainProduct && (
          <MainProduct
            mainProduct={mainProduct}
            salePercentage={salePercentage}
          />
        )}
        <div className="playdog-bundle-products__sub">
          {subProducts.length > 0 &&
            subProducts
              .slice(0, 4)
              .map((subProduct: any, index: number) => (
                <SubProduct key={index} subProduct={subProduct} />
              ))}
        </div>
      </div>
      <BundlePrice
        prices={prices}
        type={EBundlesInternalViewModel.PLAYDOG}
        buttonTextColor={bundleButtonTextColor}
        buttonColor={bundleButtonColor}
        isPreview={inMobileMock}
        isTextAutoResized
      />
    </StyledPlaydogBundle>
  );
};
